const enum LANGUAGES {
  PL = 'pl',
  EN = 'en'
}

export default LANGUAGES;
